var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 78,
  height: 145,
  fill: "none",
  viewBox: "0 0 78 145"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#b8fc75",
  strokeWidth: 5,
  clipPath: "url(#svg-public/img/quota-landing/family/spaceToEach/arrow.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.06 27.272 24.673 24.2l.532 22.434"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M33.304 109.44c19.55-1.417 44.902-33.807-4.579-81.173"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/quota-landing/family/spaceToEach/arrow.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M77.731 8.56 20.22 0 0 135.841l57.512 8.56z"
})))));
export { SvgArrow as ReactComponent };